<template>
  <button class="" v-on:click="$emit('click',$event.target)">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "fottyButton"
};
</script>

<style lang="scss" scoped>
button {
  @extend %bRadius;
  color: #fff !important;
  font-size: 16px !important;
  line-height: 24px !important;
  font-weight: 500 !important;
  transition: all 0.2s !important;
  cursor: pointer;
  &.btn-fb {
    padding:0;
    background-color: #4267b2;
    border-color: #4267b2;

    // padding: 12px 0;
    a {
      display: block;
      // padding: 12px 0;
    }
  }
  &.btn-vk {
    padding:0;
    background-color: #3580bf;
    border-color: #3580bf;
    padding: 6px 0;
    a {
      display: block;
      padding: 6px 0;
    }
  }
}
</style>